<template>
    <div>
        <h1>FQD Import</h1>
        <select v-model="cycler" style="width: 500px">
          <option value="false" selected disabled>
            Ger&auml;t auswählen.
          </option>
          <option v-for="o in this.$store.getters.cyclers" v-bind:key="o.cyclerId" :value="o.serial">
            {{o.name}}
          </option>
        </select>
        <div v-if="cycler">
                <div class="docarea errored btn" @drop.prevent="onDrop">
                    <div v-if="locked == false" style="color:#000">
                        <center><svg class="box__icon" xmlns="http://www.w3.org/2000/svg" width="50" height="43" viewBox="0 0 50 43"><path d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"></path></svg>
                        <br/><b style="color:#000">FQD</b> Datei hierher ziehen</center>
                    </div>
                    <div v-if="locked">
                        <div class="loading1">
                            <div class="loading-text">
                                <span class="loading-text-words">P</span>
                                <span class="loading-text-words">R</span>
                                <span class="loading-text-words">O</span>
                                <span class="loading-text-words">C</span>
                                <span class="loading-text-words">E</span>
                                <span class="loading-text-words">S</span>
                                <span class="loading-text-words">S</span>
                                <span class="loading-text-words">I</span>
                                <span class="loading-text-words">N</span>
                                <span class="loading-text-words">G</span>
                            </div>
                        </div>
                    </div>
                </div>
        </div>

<table style="width: 500px" v-if="files.filter(f => f.id !== false).length">
  <thead>
    <th>Original Datei</th>
    <th>Resultat</th>
  </thead>
  <tbody>
    <tr v-for="f in files.filter(f => f.id !== false)" v-bind:key="f.name" v-on:click="Download(f)">
      <td>{{f.name}}</td>
      <td width="120">
        <u>Herunterladen</u>
      </td>
    </tr>
  </tbody>
</table>


    </div>
</template>
<style scoped>
.docarea {
	display: grid;
	grid-template-rows: 1fr;
	grid-template-columns: 1fr;
    height: 200px;
    width: 500px;
    margin-top: 20px;
    user-select: none;
  background: #fff;
}
.docarea svg {
    fill: #000;
}
.docarea div {
  justify-self: center;
  align-self: center;
	grid-row: 1;
	grid-column: 1;
  color: var(--primary-color);
}
.pending {
    background-color: #2e6347;
    color: #000;
    padding: 10px;
    width: 500px;
    margin-top: 15px;
}


.loading1 {
    height: 100px;
    width: 500px;
  z-index: 9999;
}

.loading-text {
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  width: 100%;
  height: 100px;
  line-height: 100px;
}
.loading-text span {
  display: inline-block;
  margin: 0 5px;
  color: #000;
  font-family: "Quattrocento Sans", sans-serif;
}
.loading-text span:nth-child(1) {
  filter: blur(0px);
  -webkit-animation: blur-text 1.5s 0s infinite linear alternate;
          animation: blur-text 1.5s 0s infinite linear alternate;
}
.loading-text span:nth-child(2) {
  filter: blur(0px);
  -webkit-animation: blur-text 1.5s 0.2s infinite linear alternate;
          animation: blur-text 1.5s 0.2s infinite linear alternate;
}
.loading-text span:nth-child(3) {
  filter: blur(0px);
  -webkit-animation: blur-text 1.5s 0.4s infinite linear alternate;
          animation: blur-text 1.5s 0.4s infinite linear alternate;
}
.loading-text span:nth-child(4) {
  filter: blur(0px);
  -webkit-animation: blur-text 1.5s 0.6s infinite linear alternate;
          animation: blur-text 1.5s 0.6s infinite linear alternate;
}
.loading-text span:nth-child(5) {
  filter: blur(0px);
  -webkit-animation: blur-text 1.5s 0.8s infinite linear alternate;
          animation: blur-text 1.5s 0.8s infinite linear alternate;
}
.loading-text span:nth-child(6) {
  filter: blur(0px);
  -webkit-animation: blur-text 1.5s 1s infinite linear alternate;
          animation: blur-text 1.5s 1s infinite linear alternate;
}
.loading-text span:nth-child(7) {
  filter: blur(0px);
  -webkit-animation: blur-text 1.5s 1.2s infinite linear alternate;
          animation: blur-text 1.5s 1.2s infinite linear alternate;
}
.loading-text span:nth-child(8) {
  filter: blur(0px);
  -webkit-animation: blur-text 1.5s 1.4s infinite linear alternate;
          animation: blur-text 1.5s 1.4s infinite linear alternate;
}
.loading-text span:nth-child(9) {
  filter: blur(0px);
  -webkit-animation: blur-text 1.5s 1.6s infinite linear alternate;
          animation: blur-text 1.5s 1.6s infinite linear alternate;
}
.loading-text span:nth-child(10) {
  filter: blur(0px);
  -webkit-animation: blur-text 1.5s 1.8s infinite linear alternate;
          animation: blur-text 1.5s 1.8s infinite linear alternate;
}
@-webkit-keyframes blur-text {
  0% {
    filter: blur(0px);
  }
  100% {
    filter: blur(4px);
  }
}

@keyframes blur-text {
  0% {
    filter: blur(0px);
  }
  100% {
    filter: blur(4px);
  }
}




.btn {
  width: 500px;
  height: 200px;
  border: 0.5px solid #333;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 0;
  transition: 1s;
}

.btn::before, .btn::after {
  position: absolute;
  background: #fff;
  z-index: -1;
  transition: 1s;
  content: '';
}

.btn::before {
  height: 200px;
  width: 400px;
}

.btn::after {
  width: 500px;
  height: 130px;
}

.noselect {
  -webkit-touch-callout: none;
    -webkit-user-select: none;
     -khtml-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.btn:hover::before {
  width: 0px;
  background: #fff;
}

.btn:hover::after {
  height: 0px;
  background: #fff;
}

.btn:hover {
  background: #fff;
}

select:focus {
  outline: none;
}

</style>
<script>
import { saveAs } from 'file-saver';
import axios from 'axios';

export default ({
    data() {
        return {
            files: [],
            locked: false,
            testid: false,
            cycler: false,
        }
    },
    watch: {
      cycler() {
        var cycler = this.$store.getters.cyclers.find(e => e.serial == this.cycler);
        this.$store.dispatch("showNotification", {
          text: 'Befundendes Gerät <b>'+cycler.name+' (S/N: '+cycler.serial+')</b> ausgewählt.',
          timeout: 5000,
        });
      }
    },
    mounted() {
        const events = ['dragenter', 'dragover', 'dragleave', 'drop']
            events.forEach((eventName) => {
                document.body.addEventListener(eventName, (e) => {
                    e.preventDefault();
                })
            })
    },    
    methods: {
        Download(f) {
            this.$store.dispatch("DownloadTXTfromFQD", f.id)
            .then((data) => {
                var blob = new Blob([data], {type: "text/plain;charset=utf-8"});
                saveAs(blob, f.id+".txt");                
            })
        },
        onDrop(e) {
            e.preventDefault();
            if(this.$store.getters.getFQDQueue.filter(e => e.completed == 0).length > 0) {
                return false;
            }
            var file = e.dataTransfer.files[0],reader = new FileReader();
            var tt = this;
            tt.locked = false;
            tt.testid = false;
            reader.onload = function (event) {
                var fn = file.name.substring(file.name.length-3).toLowerCase();
                var content = event.target.result;
                content = Buffer.from(content.substring(content.indexOf(";")+8),'base64')
                content = content.toString();
                if(content.substring(0,10) == "pcrfqd0001") {
                    tt.files.push({
                        name: file.name,
                        mime: file.type,
                        content: event.target.result,
                        id: false,
                        serial: tt.cycler,
                    })
                    tt.locked = true;
                    tt.$store.dispatch("UploadFQD", tt.files)
                    .then((r) => {
                      tt.testid = r;
                      tt.locked = false;
                      tt.$store.dispatch("showNotification", {
                        text: 'Die Umwandlung Ihrer FQD Datei ist abgeschlossen.',
                      })
                      tt.files.find(e => e.id == false).id = tt.testid;
                      tt.Download({
                        id: tt.testid,
                      });
                    })
                } else {
                      tt.$store.dispatch("showNotification", {
                        text: 'Die ausgewählte Datei ist keine gültige BIOER FQD Datei.',
                      })                  
                }
            }
            reader.readAsDataURL(file);
        }
    }
})
</script>
